import React from "react";
import moment from "moment";
import { Table } from "react-bootstrap";
import Barcode from 'react-barcode';
import "../../pages/liveManage/liveDetail/liveDetail.css";
import { thousandSeperate } from "../../helpers";

export default class OrderBillWithNameOnePageV2 extends React.PureComponent {
  render() {
    let data = this.props.data;
    let shopData = this?.props?.shopData;
    let SHOP_DATA = JSON.parse(localStorage.getItem("SHOP_DATA"));

    const checkBockStyle = {
                          width: "20px",
                          height: "20px",
                          marginRight: "8px",
                          border: "2px solid #333",
                          borderRadius: "3px",
                          backgroundColor: "#fff",
                          display: "inline-block",
                          position: "relative",
                          cursor: "pointer"
                        }

    const address = (item) => {
      let location = item?.addressCf;
      if (item?.orderDelivery?.id){
        const receiver = item?.orderDelivery?.receiver;
        location = `${receiver?.province}, ${receiver?.district}, ${receiver?.village}`;
      };
      if (!location) return item?.destinationLogistic || '';
      return location;
    }
    const express = (item) => {
      let ex = item?.addressCf === item?.logistic ? "" : item?.logistic;
      if (!ex){
        switch (item?.orderDelivery?.delivery) {
          case "HAL" :
            return "ຮຸ່ງອາລຸ່ນ";
          case "MIXAY" :
            return "ມີໄຊ";
          default:
            return "";
        }
      }
      return ex;
    }
    return (
      <div>
        {data?.map((item, index) => (
          <div
            key={index}
            style={{
              // border: "1px solid black",
              breakInside: "avoid",
              padding: "20px",
              fontWeight: "bold",
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px",
                borderBottom: "1px solid #ddd"
              }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <span style={{ color: "black", fontSize: "35px", marginRight: "10px" }}>
                    ເລກອໍເດີ້ທີ່:
                  </span>
                  <span style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>
                    {item?.code}
                  </span>
                </div>
                <span style={{ color: "black", fontSize: "35px" }}>
                  {moment(item?.createdAt).format("DD/MM/YYYY HH:ss a")}
                </span>
              </div>
              <div>
                <div style={{ background: 'white', padding: '10px', display: 'inline-block' }}>
                  <Barcode
                    value={String(item?.code || '')}
                    width={2.5}
                    height={80}
                    margin={0}
                    format="CODE128"
                    displayValue={false}
                    background="white"
                    lineColor="#000000"
                  />
                </div>
              </div>
            </div>

            {/* ======= Box CustommerName ======= */}
            <div
              style={{
                display: "flex",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}>
              <div
                style={{
                  width: "30%",
                  color: "black",
                  textAlign: "center",
                  border: "1px solid black",
                }}>
                <div style={{ color: "black", fontSize: "35px",fontWeight:"bold" }}>
                  ບິນແພັກເຄື່ອງ
                </div>
                {/* <div style={{ color: "black", fontSize: "35px" }}>Receipt</div> */}
              </div>
              <div
                style={{
                  color: "black",
                  width: "70%",
                  padding: "10px",
                  border: "1px solid black",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <div style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>
                  ຊື່ຜູ້ສົ່ງ : {SHOP_DATA?.name ?? ""}
                </div>
                <div style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>
                  ເບີໂທ : {SHOP_DATA?.phone ?? ""}
                </div>
              </div>
            </div>
            {/* ======= end Box CustommerName ======= */}

            {/* =======  Box Detail Address ======= */}

            <div style={{ padding: "20px 20px 0px 20px" }}>
              <div
                style={{
                  display: "flex",
                  fontSize: "35px",
                  border: "1px solid black",
                }}>
                <div
                  style={{
                    width: "50%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px",
                    fontWeight: "bold",
                  }}>
                  <span style={{ color: "black", fontSize: "35px" }}>
                    ຊື່ລູກຄ້າ : {item?.customerName ?? item?.cfName}{" "}
                  </span>
                  {/* <span style={{ color: "black", fontSize: "35px" }}>Customer Name</span> */}
                  <span style={{ color: "black", fontSize: "35px" }}>
                    ເບີໂທລູກຄ້າ : {item?.phone ?? ""}
                  </span>
                  {/* <span style={{ color: "black", fontSize: "35px" }}>Phone Number</span> */}
                </div>
                <div
                  style={{
                    width: "50%",
                    borderLeft: "1px solid black",
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px",
                    fontWeight: "bold",
                  }}>
                  <span style={{ color: "black", fontSize: "35px" }}>
                    ທີ່ຢູ່ : {address(item)}{" "}
                  </span>
                  {/* <span style={{ color: "black", fontSize: "35px" }}>Address</span> */}
                  {item?.orderDelivery?.delivery  && 
                    (
                      <span style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>
                        ຂົນສົ່ງ : {express(item)}
                      </span>
                    )
                  }
                  {/* <span style={{ color: "black", fontSize: "35px" }}>Logistic</span> {item?.logistic} */}
                </div>
              </div>
            </div>

            {/* ======= end Box Detail Address ======= */}

            {/* =======  tableList  ======= */}
            <div style={{ padding: "20px", fontSize: "35px" }}>
              <Table striped bordered hover>
                <thead style={{ background: "black" }}>
                  <tr>
                    <th style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>ລ/ດ</th>
                    <th style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>ລາຍການ</th>
                    <th style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>ຈຳນວນ</th>
                    {shopData?.exampleBill === "ISPRICE_BOLD" ? (
                      <>
                        <th style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>ລາຄາ</th>
                        <th style={{ color: "black", fontSize: "35px", fontWeight: "bold" }}>
                          ລາຄາລວມ
                        </th>
                      </>
                    ) : (
                      ""
                    )}

                  </tr>
                </thead>
                {shopData?.exampleBill === "ISPRICE_BOLD" ? (
                  <tbody>
                    {item?.orders?.length > 0 &&
                      item?.orders?.map((order, orderIndex) => (
                        <tr key={orderIndex}>
                          <td
                            scope="row"
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            {orderIndex + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              textAlign: "start",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            ({order?.cfMessage}) {order?.productName}
                          </td>
                          <td
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            {order?.amount}
                          </td>

                          <td
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            {thousandSeperate(order?.price)} {order?.currency}
                          </td>
                          <td style={{ color: "black", fontSize: "32px", fontWeight: "bold" }}>
                            {thousandSeperate(order?.amount * order?.price)}{" "}
                            {order?.currency}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                ) : (
                  <tbody>
                    {item?.orders?.length > 0 &&
                      item?.orders?.map((order, orderIndex) => (
                        <tr key={orderIndex}>
                          <td
                            scope="row"
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            {orderIndex + 1}
                          </td>
                          <td
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              textAlign: "start",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            ({order?.cfMessage}) {order?.productName}
                          </td>
                          <td
                            style={{
                              color: "black",
                              borderRight: "1px solid grey",
                              fontSize: "32px",
                              fontWeight: "bold",
                            }}>
                            {order?.amount}
                          </td>

                        </tr>
                      ))}
                  </tbody>
                )}

              </Table>

              <div style={{ color: "black", fontSize: "40px", fontWeight: "bold" }}>
                {" "}
                ທັງໝົດ {item?.orders?.length ?? 0} ລາຍການ
              </div>
              <hr />
              <div
                style={{
                  display: "flex",
                  fontSize: "35px",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  pageBreakInside: "avoid",
                }}>
                {/* Payment Methods Section */}
                <div style={{ 
                  display: "flex", 
                  flexDirection: "column",
                  flex: 1,
                  marginRight: "20px"
                }}>
                  <div style={{ 
                    color: "black", 
                    fontSize: "32px",
                    fontWeight: "bold",
                    marginBottom: "15px",
                    borderBottom: "2px solid #333",
                    paddingBottom: "5px"
                  }}>
                    ການຊຳລະເງິນ
                  </div>
                  
                  {/* First row of payment methods */}
                  <div style={{ 
                    display: "flex", 
                    paddingTop: "15px",
                    flexWrap: "wrap",
                    gap: "15px"
                  }}>
                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ເງິນສົດ
                      </div>
                    </div>

                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ເງິນໂອນ
                      </div>
                    </div>

                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ປາຍທາງ
                      </div>
                    </div>
                  </div>
                  
                  {/* Second row of payment methods */}
                  <div style={{ 
                    display: "flex", 
                    paddingTop: "15px",
                    flexWrap: "wrap",
                    gap: "15px"
                  }}>
                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ຮຸ່ງອາລຸນ
                      </div>
                    </div>

                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ອານຸສິດ
                      </div>
                    </div>

                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ກັບຕັນ
                      </div>
                    </div>
                  </div>
                  
                  {/* Third row of payment methods */}
                  <div style={{ 
                    display: "flex", 
                    paddingTop: "15px",
                    flexWrap: "wrap",
                    gap: "15px"
                  }}>
                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ກຽງໄກ
                      </div>
                    </div>
                    
                    <div style={{ 
                      display: "flex", 
                      alignItems: "center",
                      minWidth: "120px"
                    }}>
                      <div style={checkBockStyle} />
                      <div style={{ 
                        color: "black", 
                        fontSize: "30px",
                        fontWeight: "bold"
                      }}>
                        ມີໄຊ
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Total Amount Section */}
                {shopData?.exampleBill === "ISPRICE_BOLD" && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      minWidth: "300px",
                      padding: "20px",
                      border: "2px solid #333",
                      borderRadius: "8px",
                      backgroundColor: "#f8f9fa"
                    }}>
                    <div style={{ 
                      color: "black", 
                      fontSize: "32px",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      textAlign: "center",
                      width: "100%",
                      borderBottom: "1px solid #666",
                      paddingBottom: "10px"
                    }}>
                      ລວມທັງໝົດ
                    </div>
                    
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        marginBottom: "10px",
                        padding: "8px 0"
                      }}>
                      <div style={{ 
                        color: "black", 
                        fontSize: "32px",
                        fontWeight: "bold"
                      }}>
                        ກີບ:
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "35px",
                          color: "#d63384",
                          textAlign: "right"
                        }}>
                        {thousandSeperate(item?.totalPrice ?? 0)}
                      </div>
                    </div>
                    
                    {item?.sumPriceBaht > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginBottom: "10px",
                          padding: "8px 0"
                        }}>
                        <div style={{ 
                          color: "black", 
                          fontSize: "32px",
                          fontWeight: "bold"
                        }}>
                          ບາດ:
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "35px",
                            color: "#d63384",
                            textAlign: "right"
                          }}>
                          {thousandSeperate(item?.sumPriceBaht ?? 0)}
                        </div>
                      </div>
                    )}
                    
                    {item?.sumPriceUsd > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          marginBottom: "10px",
                          padding: "8px 0"
                        }}>
                        <div style={{ 
                          color: "black", 
                          fontSize: "32px",
                          fontWeight: "bold"
                        }}>
                          ໂດລາ:
                        </div>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "35px",
                            color: "#d63384",
                            textAlign: "right"
                          }}>
                          {thousandSeperate(item?.sumPriceUsd ?? 0)}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {/* ======= end tableList ======= */}
          </div>
        ))}
      </div>
    );
  }
}
